import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  signal,
  ViewChild
} from '@angular/core';
import {
  FlowChartArrowPosition,
  NgFlowchartArrowViewModel
} from '../../../../models/right-request-steps/right-request-step.model';
import { isDefined, isUndefined } from '../../../../util';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  selector: 'ng-flowchart-arrow',
  standalone: true,
  styleUrls: ['ng-flowchart-arrow.component.scss'],
  templateUrl: 'ng-flowchart-arrow.component.html'
})
export class NgFlowchartArrowComponent implements AfterViewInit, OnInit {
  @ViewChild('arrow') public arrow: ElementRef;

  private isLeftFlowing: boolean = false;
  private padding: number = 10; // To be applied on left and right edges
  private position: FlowChartArrowPosition;

  public vm: NgFlowchartArrowViewModel;

  public ngOnInit(): void {
    this.vm = {
      containerHeight: signal(0),
      containerLeft: signal(0),
      containerTop: signal(0),
      containerWidth: signal(0),
      opacity: signal(1)
    };
  }

  public ngAfterViewInit(): void {
    setTimeout((): void => {
      this.setContainerDataFromPosition();
      this.updatePath();
    }, 50); // Delay so that component is fully rendered
  }

  public hideArrow(): void {
    this.vm.opacity.set(.2);
  }

  public showArrow(): void {
    this.vm.opacity.set(1);
  }

  public setPosition(pos: FlowChartArrowPosition): void {
    this.position = pos;

    if (isDefined(this.vm)) {
      this.setContainerDataFromPosition();
      this.updatePath();
    }
  }

  private setContainerDataFromPosition(): void {
    this.isLeftFlowing = this.position.start[0] > this.position.end[0];

    // In the case where steps are directly underneath we need some minimum width
    this.vm.containerWidth.set(Math.abs(this.position.start[0] - this.position.end[0]) + (this.padding * 2));

    this.vm.containerLeft.set(Math.min(this.position.start[0], this.position.end[0]) - this.padding);

    this.vm.containerHeight.set(Math.abs(this.position.start[1] - this.position.end[1]));
    this.vm.containerTop.set(this.position.start[1]);
  }

  private updatePath(): void {
    if (isUndefined(this.arrow?.nativeElement)) {
      return;
    }

    if (this.isLeftFlowing) {
      this.arrow.nativeElement.setAttribute('d', `
        M${this.vm.containerWidth() - this.padding}, 0 
        L${this.vm.containerWidth() - this.padding}, ${this.vm.containerHeight() / 2}
        L${this.padding}, ${this.vm.containerHeight() / 2}
        L${this.padding}, ${this.vm.containerHeight() - 4}
      `);
    } else {
      this.arrow.nativeElement.setAttribute('d', `
        M${this.padding}, 0 
        L${this.padding}, ${this.vm.containerHeight() / 2}
        L${this.vm.containerWidth() - this.padding}, ${this.vm.containerHeight() / 2}
        L${this.vm.containerWidth() - this.padding}, ${this.vm.containerHeight() - 4}
      `);
    }
  }
}
